import { useSelector } from 'react-redux'

// Components
import HomebotListingsButton from './HomebotListingsButton'
import YlopoListingsButton from './YlopoListingsButton'

// Selectors
import {
  selectDisplayYlopoSpecificContent,
  selectListingsSourceIsHomebotListings,
} from 'src/store/selectors/listings'

const ExternalListingsButton = props => {
  const showYlopoListings = useSelector(selectDisplayYlopoSpecificContent)
  const showHomebotListings = useSelector(selectListingsSourceIsHomebotListings)

  if (showHomebotListings) {
    return <HomebotListingsButton {...props} />
  } else if (showYlopoListings) {
    return <YlopoListingsButton {...props} />
  } else {
    return null
  }
}

export default ExternalListingsButton
